<template>
  <div class='device_version_top'>
    <div v-show='deviceOrLog == 0'>
      <div class='row h-row-insertBox'>
        <div class='h-col-insertBox'>
          <div class='h-inputLit col-sm-6'>
            <ejs-textbox :placeholder='$t("根据名称或版本查询")' v-model='keyString'></ejs-textbox>
          </div>
        </div>
      </div>
      <div class='row h-row-insertBox'>
        <div class='h-col-insertBox noPage'>
          <ejs-grid ref='srcGrid' height='180px' :dataSource='srcDataSource' :commandClick='onClickLog'>
            <e-columns>
              <e-column type='checkbox' width='50' textAlign='Center'></e-column>
              <e-column field='name' headerText='设备名称' width='70' clipMode='EllipsisWithTooltip'></e-column>
              <e-column field='runningVersion' headerText='运行版本' width='90' textAlign='Center'
                        :formatter='runVersionFormatter' clipMode='EllipsisWithTooltip'></e-column>
              <e-column field='storeVersion' headerText='存储版本' width='90' textAlign='Center'
                        :formatter='storeVersionFormatter' clipMode='EllipsisWithTooltip'></e-column>
              <e-column field='softwareVersion' headerText='本地版本' width='90' textAlign='Center'
                        clipMode='EllipsisWithTooltip'></e-column>
              <e-column field='upgradeTime' headerText='上次升级时间' width='90' textAlign='Center'
                        :formatter='upgradeFormatter' clipMode='EllipsisWithTooltip'></e-column>
              <e-column field='oper' headerText='同步操作' width='90' textAlign='Center' :formatter='operFormatter'
                        clipMode='EllipsisWithTooltip'></e-column>
              <e-column headerText='日志' width='90' textAlign='Center' :commands='commandsAdd'></e-column>
            </e-columns>
          </ejs-grid>
        </div>
      </div>
      <div class="row h-row-inputBox">
        <div class="col-sm-4 h-col-inputBox">
          <ejs-button @click.native='srcToDes'>{{buttonText}}</ejs-button>
        </div>
        <div class='col-sm-4 h-col-inputBox'>
          <div class='h-inputLit col-sm-6'>{{this.$t('升级时间')}}</div>
          <ejs-datepicker class='e-input e-disabled e-input-group' :format='dateFormat'
                          v-model='oprTime' :locale='locale'></ejs-datepicker>
        </div>
        <div class="col-sm-4 h-col-inputBox" v-show='upOrBack==0'>
          <ejs-dropdownlist ref='upVersion' :dataSource="versionList"></ejs-dropdownlist>
        </div>
      </div>
      <div class='device_version_down'>
        <div class='row h-row-insertBox'>
          <div class='h-col-insertBox noPage'>
            <ejs-grid ref='desGrid' height='180px' :dataSource='desDataSource' :commandClick='onClickDel'>
              <e-columns>
                <e-column headerText='操作' width='90' textAlign='Center' :commands='commandsDel'></e-column>
                <e-column field='name' headerText='设备名称' width='70' clipMode='EllipsisWithTooltip'></e-column>
                <e-column field='runningVersion' headerText='运行版本' width='200' textAlign='Center'
                          :formatter='runVersionFormatter' clipMode='EllipsisWithTooltip'></e-column>
                <e-column field='storeVersion' headerText='存储版本' width='90' textAlign='Center'
                          :formatter='storeVersionFormatter' clipMode='EllipsisWithTooltip'></e-column>
                <e-column field='softwareVersion' headerText='本地版本' width='90' textAlign='Center'></e-column>
              </e-columns>
            </ejs-grid>
          </div>
        </div>
        <div v-show='upOrBack==0'>
          <div class='row h-row-insertBox'>
            <div class='h-col-insertBox'>
              <div class='h-inputLit col-sm-6'>{{this.$t('步骤')}}</div>
            </div>
          </div>
          <div class='row h-row-insertBox'>
            <div class='h-col-insertBox'>
              <div class='col-sm-2 h-col-inputBox'>
                <ejs-checkbox label='下载' ref='downLoad' :checked='true'></ejs-checkbox>
              </div>
              <div class='col-sm-2 h-col-inputBox'>
                <ejs-checkbox label='推送' ref='push' :checked='false'></ejs-checkbox>
              </div>
              <div class='col-sm-2 h-col-inputBox'>
                <ejs-checkbox label='激活' ref='active' :checked='false'></ejs-checkbox>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div v-show='deviceOrLog == 1'>
      <ejs-button @click.native='returnDevice'>返回</ejs-button>
      <DeviceVersionLog ref='versionLog'></DeviceVersionLog>
    </div>
  </div>
</template>

<script>
  import {CommandColumn} from '@syncfusion/ej2-vue-grids';
  import {EventBus} from '../../../plugins/eventBus';
  import {stringify} from 'qs';
  import DeviceVersionLog from './DeviceVersionLog';

  export default {
    name: 'DeviceVersion',
    components: {
      DeviceVersionLog
    },
    provide: {
      grid: [CommandColumn]
    },
    data() {
      return {
        commandsAdd: [{buttonOption: {content: '详情', cssClass: 'e-flat'}}],
        commandsDel: [{buttonOption: {content: '删除', cssClass: 'e-flat'}}],
        srcDataSource: [], // neid唯一判别标识符
        desDataSource: [],
        locale: localStorage.getItem('locale'),
        buttonText: '',
        oprTime: '',
        dateFormat: 'yyyy-MM-dd HH:mm:ss',
        oprMap: {
          0: '升级',
          1: '回退'
        },
        upOrBack: 0,
        keyString: '',
        versionList: [],
        tempInfo: {typeCode: -1, version: ''}, // 判断升级所选设备是否是同类型，同版本属性
        deviceOrLog: 0
      }
    },
    methods: {
      init(param) {
        // 初始参数赋值
        this.upOrBack = param['upOrBack'];
        this.srcDataSource = param['dataSource'];
        if (this.upOrBack === 0) {
          this.buttonText = '加入待升级列表';
        } else {
          this.buttonText = '加入待回退列表';
        }
      },
      // src2des
      srcToDes() {
        const record = this.$refs.srcGrid.ej2Instances.getSelectedRecords();
        let noDo = false;
        if (this.upOrBack == 0) {
          noDo = this.checkSameType(record);
        }
        if (noDo) {
          return null;
        }
        this.srcDataSource = this.srcDataSource.filter(item => {
          let neidList = record.map(re => re.id);
          return !neidList.includes(item.id);
        });
        this.desDataSource = this.desDataSource.concat(record);
      },
      // des2src
      onClickDel(args) {
        const data = args.rowData;
        this.desDataSource = this.desDataSource.filter(item => item.id != data.id);
        this.srcDataSource = this.srcDataSource.concat([data]);
        if (this.desDataSource == null || this.desDataSource.length == 0) {
          this.tempInfo['typeCode'] = -1;
          this.versionList = [];
        }
      },
      // 检查升级设备是否为同类型设备
      checkSameType(record) {
        if (this.tempInfo['typeCode'] == -1) {
          this.tempInfo['typeCode'] = record[0]['typeCode'];
          this.tempInfo['version'] = record[0]['displaySoftwareVersion'];
          const isNullArray = record.filter(item => {
            const typeCode = item['typeCode'];
            const version = item['displaySoftwareVersion'];
            if (typeCode != this.tempInfo['typeCode'] || version != this.tempInfo['version']) {
              return item;
            }
          });
          if (isNullArray != null && isNullArray.length != 0) {
            this.tempInfo['typeCode'] == -1;
            this.eventEmit('warning', `${this.$t("请选择同类型，同运行版本设备")}`);
            return true;
          }
          // 查询设备能升级到的版本信息
          this.getTypeVersionList();
          return false;
        } else {
          const isNullArray = record.filter(item => {
            const typeCode = item['typeCode'];
            const version = item['displaySoftwareVersion'];
            if (typeCode != this.tempInfo['typeCode'] || version != this.tempInfo['version']) {
              return item;
            }
          });
          if (isNullArray != null && isNullArray.length != 0) {
            this.eventEmit('warning', `${this.$t("请选择与已选设备同类型，同运行版本的设备")}`);
            return true;
          }
          return false;
        }
      },
      // 查询设备能升级到的版本信息
      getTypeVersionList() {
        const url = '/lte/ems/packageManager/queryServiceAll';
        const params = {
          oamTypeCode: this.tempInfo['typeCode']
        };
        this.$axios.get(url, {params}).then(response => {
          const result = response.data;
          const tempVersionNum = this.tempInfo['version'].split('_V')[1].replace('.', '');
          this.versionList = result.map(item => {
            const itemVersionNum = item['pkgVersion'].split('_V')[1].replace('.', '');
            if (parseInt(itemVersionNum) >= parseInt(tempVersionNum)) {
              //  只考虑了版本号全为数字情形
              return item['pkgVersion'];
            }
          });
        });
      },
      onClickLog(args) {
        const data = args.rowData;
        const param = {
          upOrBack: this.upOrBack,
          name: data['name']
        };
        this.$refs.versionLog.init(param);
        this.deviceOrLog = 1;
      },
      returnDevice() {
        this.deviceOrLog = 0;
      },
      getData() {
        const data = this.$refs.desGrid.ej2Instances.dataSource;
        let isDownLoad = 0;
        let isActive = 0;
        let isUpLoad = 0;
        if (this.$refs.downLoad.ej2Instances.checked) {
          isDownLoad = 1;
        }
        if (this.$refs.push.ej2Instances.checked) {
          isUpLoad = 1;
        }
        if (this.$refs.active.ej2Instances.checked) {
          isActive = 1;
        }
        const param = {};
        param['data'] = data;
        param['oprObj'] = {
          isDownLoad: isDownLoad,
          isActive: isActive,
          isUpLoad: isUpLoad
        };
        param['oprTime'] = new Date(this.oprTime).Format("yyyy-MM-dd HH:mm:ss");
        return param;
      },
      confirm() {
        console.log(this.$refs.upVersion.ej2Instances.text);
        if (this.desDataSource.length == 0 || this.desDataSource == null) {
          this.eventEmit("warning", `${this.$t("请选择执行升级/回退的设备")}`);
          return null;
        }
        if (this.upOrBack == 0 && this.$refs.upVersion.ej2Instances.text == null) {
          this.eventEmit("warning", `${this.$t("请选择升级版本")}`);
          return null;
        }
        if (this.oprTime == null || this.oprTime == '') {
          this.eventEmit("warning", `${this.$t("请选择执行时间")}`);
          return null;
        }
        this.$layer.confirm({
          msg: this.$t('注意：操作后设备将重启，是否继续？'),
          btn1: {
            msg: this.$t('Common.confirm'),
            func: this.deVeCon
          }
        });
      },
      deVeCon() {
        let url = '';
        const param = {};
        const oprObj = this.getData()['oprObj'];
        const oprTime = this.getData()['oprTime'];
        const data = this.getData()['data'];
        if (this.upOrBack === 0) {
          // 升级
          url = `/lte/ems/packageManager/upgradeDevice?isActive=${oprObj['isActive']}&isUpLoad=${oprObj['isUpLoad']}&isDownLoad=${oprObj['isDownLoad']}&isFilter=0&execTime=${oprTime}`;
          param['neIds'] = data.map(item => {
            return item.id
          });
          param['versionList'] = [this.$refs.upVersion.ej2Instances.text];
        } else {
          // 回退
          url = `/lte/ems/packageManager/backDevice?execTime=${oprTime}`;
          param['neIds'] = data.map(item => {
            return item.id
          });
        }
        this.$axios.post(url, param).then(response => {
          console.log(response);
        });
      },
      // 判断运行版本是否为空
      runVersionFormatter(grids, data) {
        if (data.runningVersion === undefined || data.runningVersion === null || data.runningVersion === '') {
          return '--';
        }
      },
      // 判断存储版本是否为空
      storeVersionFormatter(grids, data) {
        if (data.storeVersion === undefined || data.storeVersion === null || data.storeVersion === '') {
          return '--';
        }
      },
      // 判断升级时间是否为空
      upgradeFormatter(grids, data) {
        if (data.upgradeTime === undefined || data.upgradeTime === null || data.upgradeTime === '') {
          return '--';
        }
      },
      // 判断升级操作是否为空
      operFormatter(grids, data) {
        if (data.oper === undefined || data.oper === null || data.oper === '') {
          return '--';
        }
      },
      eventEmit(type, content) {
        EventBus.$emit('toast', {type: type, content: content})
      }
    }
  }
</script>

